import { getCustomActionsOverrides } from './getCustomActionsOverrides';
import { IEditActionSource } from '../types';
import { isSingleSelection } from '../utils';

export class CustomActionSource extends IEditActionSource {
  getDefinitions() {
    const { componentsAPI, editorPointers } = this.ctx;

    let overrides = {};
    if (isSingleSelection(editorPointers)) {
      overrides = getCustomActionsOverrides(this.ctx, editorPointers[0]);
    }

    return {
      ...(componentsAPI.components.getCustomActions(editorPointers) || {}),
      ...overrides,
    };
  }
}
